import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const CommentSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default CommentSVG;
